import { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
// import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import OnboardingFormAddAndEditModal from "./ModalContent/OnboardingFormModal";
import { useNavigate } from "react-router-dom";
import { useOnBoardRequiredFieldsListData } from "./hooks/useOnBoard";
const onboardingFormDataColumns = (handleUpdate: (row: any) => void) => [
  {
    name: "Organisation Unit",
    selector: (row: { OrgUnit: string | any }) => row.OrgUnit?.UnitName || "-",
    sortable: true,
    minWidth: "250px",
    wrap: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { OutletType: string | any }) =>
      row.OutletType?.OutlettypeName || "-",
    sortable: true,
    minWidth: "250px",
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { StatusName: string | any }) => row.StatusName || "-",
    sortable: true,
    minWidth: "250px",
    wrap: true,
  },
  {
    name: "Required Fields",
    selector: (row: { RequiredFields: string | any }) =>
      row.RequiredFields?.join(",") || "-",
    sortable: true,
    minWidth: "250px",
    wrap: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleUpdate(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} />
          Edit
        </button>
      </div>
    ),
    width: "150px",
  },
];

const OnboardingForm = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const [paginationStates, setPaginationStates] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
    sortColumn: "OnBoardRequiredFieldsId",
  });
  const [rowData, setRowData] = useState(null);
      const [isDownloading,setIsDownloading]=useState(false)

  const { data, isLoading } = useOnBoardRequiredFieldsListData({
    enable: true,
    params: {
      limit: paginationStates.limit,
      page: paginationStates.page,
      search: paginationStates.search,
    },
  });

  console.log(
    "🚀 ~ OnboardingForm.tsx:79 ~ OnboardingForm ~ data:",
    data?.data?.data?.recordsTotal
  );

  // console.log(
  //   "dataaa OnBoardRequiredFieldsListData",
  //   data?.data?.data?.recordsTotal
  // );
  //  alert(JSON.stringify(rowData))

  const handleUpdate = (row: any) => {
    setRowData(row);
    setCheckAddEditStatus("Edit");
    setIsModalOpen(true);
  };

  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

      const handleExcel = async () => {
  try {
    setIsDownloading(true);

    const appToken = localStorage.getItem("Apptoken") || "";
   
   
    const search = paginationStates.search || "";

    const params = new URLSearchParams();

    // Append only if the value exists

    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getOnBoardRequiredFieldsExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "OnBoard Required Fields Excel.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }  finally{
     setIsDownloading(false);
  }
};

  return (
    <div className="p-2">
      <PageHeader
        title="Onboarding Forms"
        buttons={[
          {
            label: "+ Add New",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
             {
            label: isDownloading ? "Downloading..." : "Excel",
            onClick:handleExcel,
            color: "#43B9B2",
            disable:isDownloading

          },
        ]}
      />

      <BasicDataTable
        paginationTotalRows={data?.data?.data?.recordsTotal}
        showSpinner={isLoading}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Required Fields"
        columns={onboardingFormDataColumns(handleUpdate)}
        dynamicHeightOnRowsPerPage={true}
        data={data?.data?.data?.data || []}
      />
      <OnboardingFormAddAndEditModal
        rowData={rowData}
        setCheckAddEditStatus={setCheckAddEditStatus}
        checkAddEditStatus={checkAddEditStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        title={
          checkAddEditStatus == "Add"
            ? "Add Onboard Required Fields"
            : "Edit Onboard Required Fields"
        }
      />
    </div>
  );
};

export default OnboardingForm;
